<template>    
    <!-- Inizio Header -->
    <header class="Header">
        <div class="Container">
            <div class="BoxWide">
                <div class="Logo"><a href="/#default" title="Home"><img src="/CmsData/imagefolder/Loginlogo.png" srcset="/CmsData/imagefolder/LoginlogoRetina.png 2x" alt="" /></a></div>
                <div class="MainMenuHolder">
                    <div class="MainMenuButton"><a @click="this.mainmenu();" style="cursor:pointer;"><img src="/App_Skins/Sito/images/Spacer.png" alt="" /></a></div>
                    <div class="MainMenu">
                        <ul>
                            <li><router-link @click.prevent="closemenu()" :to="{name : 'Home'}">Home</router-link></li>
                            <li><router-link @click.prevent="closemenu()" :to="{name : 'Interventi'}">Interventi</router-link></li>
                            <li><router-link @click.prevent="closemenu()" :to="{name : 'Scadenzario'}">Scadenzario</router-link></li>
                            <li><router-link @click.prevent="closemenu()" :to="{name : 'Entita'}">Entità</router-link></li>
                            <li><router-link @click.prevent="closemenu()" :to="{name : 'Contratti'}">Contratti</router-link></li>
                            <li><span>Altri documenti</span></li>
                            <li><router-link @click.prevent="closemenu()" :to="{name : 'MyAccount'}"> My account</router-link></li>
                            <li><a class="Logout" href="javascript:void(0)" @click="this.logout()">Logout</a></li>
                        </ul>
                    </div>
                    <div class="PersonalPin">{{ this.$store.getters.getInizialiUtente}}</div><!-- Stampare le iniziali dell'utente -->
                </div>
            </div>
        </div>
    </header>
    <!-- Fine Header -->
</template>
<script>
export default {
    name: "Header",
    methods: {
        mainmenu: function(){            
            if ($('body').hasClass('mainmenu')) {
                $('body').removeClass('mainmenu');
            }
            else {
                $('body').addClass('mainmenu');
            }
        },
        closemenu(){
            $('body').removeClass('mainmenu');
        },
        logout(){
            this.$store.commit('logout');
            this.$router.push("/");
        }
    }
}
</script>